import { render, staticRenderFns } from "./AmbassadorDashboard.vue?vue&type=template&id=59844901&"
import script from "./AmbassadorDashboard.vue?vue&type=script&lang=js&"
export * from "./AmbassadorDashboard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports